// The "Select: All · None · All high-confidence · All high + medium" row.
//
// Shared by the bulk enrich grid and the single-ref review table so the two
// screens offer the same shortcuts under the same names. Presentational only —
// each screen owns its own tick state (see suggestionSelection.ts for why).

import { SELECTION_MODES, type SelectionMode } from './suggestionSelection';

interface Props {
  onSelect: (mode: SelectionMode) => void;
  disabled?: boolean;
  /** Optional trailing note, e.g. "12 of 15 selected — 3 held back". */
  note?: string;
}

export function SuggestionSelectToolbar({ onSelect, disabled, note }: Props) {
  return (
    <div className="flex items-center gap-2 text-xs">
      <span className="text-gray-500">Select:</span>
      {SELECTION_MODES.map(({ mode, label }, i) => (
        <span key={mode} className="flex items-center gap-2">
          {i > 0 && <span className="text-gray-300">·</span>}
          <button
            type="button"
            className="text-indigo-600 hover:underline disabled:text-gray-300"
            onClick={() => onSelect(mode)}
            disabled={disabled}
          >
            {label}
          </button>
        </span>
      ))}
      {note && <span className="text-gray-500">{note}</span>}
    </div>
  );
}
